<template>
  <div class="search_dp">
    <transition-group
      name="staggered-fade"
      tag="ul"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave"
    >
      <li
        v-for="(item, index) in servicos"
        :key="index + 1"
        class="lista_servico d-flex align-items-center"
        :data-index="index"
      >
        <!-- <router-link :to="`/servico/${item.id}`" class="my-0 pl-3 d-flex justify-content-between classLink">
					<div>
						<strong>{{item.serviceName}} |</strong>
						{{item.categoryName}}
					</div>

					<span>
						 {{item.value | currency }}
					</span>
				</router-link> -->
        <a
          @click="redirectRouterService(item)"
          class="my-0 pl-3 d-flex justify-content-between classLink"
        >
          <div>
            <strong>{{ item.serviceName }} |</strong>
            {{ item.categoryName }}
          </div>

          <span>
            {{ item.value | currency }}
          </span>
        </a>
      </li>
      <li
        v-if="$store.getters.getUser.profile != 1"
        class="solicitar d-flex align-items-center"
        :data-index="servicos.length + 1"
        :key="servicos.length + 1"
        @click.prevent="openModal()"
      >
        <a href="#" class="my-0 pl-3">
          <strong>Solicitar |</strong>
          novo serviço
        </a>
      </li>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: ["servicos"],
  computed: {
    user() {
      return this.$store.getters.getUser.profile;
    }
  },
  methods: {
    redirectRouterService({ id }) {
      if (this.$store.getters.get_tenant.type == 4 && this.$store.getters.getUser.profile != 1) {
        this.$emit("showModalDegustacaoHeader");
      } else {
        if (this.user !== 3) {
          this.toast(
            "Para Realizar algum serviço acessa o perfil vendedor!",
            this.$toast
          );
          return;
        }
        this.$router.push(`/servico/${id}`);
      }
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.height = 0;
    },
    enter: function(el, done) {
      var delay = el.dataset.index;

      setTimeout(function() {
        $(el).velocity({ opacity: 1, height: "50px" }, { complete: done });
      }, delay);
    },
    leave: function(el, done) {
      var delay = el.dataset.index;
      setTimeout(function() {
        $(el).velocity({ opacity: 0, height: 0 }, { complete: done });
      }, delay);
    },
    openModal() {
      if (this.$store.getters.get_tenant.type == 4 && this.$store.getters.getUser.profile != 1) {
        this.$emit("showModalDegustacaoHeader");
      } else {
        $(".dropdown-menu").fadeOut(500);
        $(".sub_menu").removeAttr("style");
        $(".search_dp").fadeOut(500);
        $("header").css({ "z-index": "3" });
        $(".input_search_list").removeAttr("style");
        $(".navegation_item.active_item").removeClass("active_item");
        $("#app").removeClass("overlay_custom");
        $("#modalSolicitarServico").modal("show");
      }
    }
  }
};
</script>

<style scoped>
ul {
  padding: 0;
  overflow: auto;
  max-height: 500px;
}

.classLink {
  flex: 1;
  cursor: pointer;
  padding-right: 5px;
}
.lista_servico {
  background-color: #2474b2;
  height: 50px;
  border-color: #1c5f93;
  border-style: solid;
  border-width: 0px 2px 2px 2px;
}
.lista_servico a {
  color: #ffffff;
}
.solicitar {
  background-color: #f38235;
  height: 50px;
  border-color: #f38235;
  border-style: solid;
  border-width: 0px 2px 2px 2px;
}
.solicitar a {
  color: #ffffff;
}
.search_dp {
  display: none;
  position: absolute;
  width: 100%;
  left: 0;

  padding-left: 15px;

  padding-right: 15px;
}
</style>
